import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { getLinks, isCurrentPage } from './services/links';
import './styles/headerLinks.scss';

export default function HeaderLinks({ localized }) {
  const links = getLinks();

  function handleNavigationLinkPress(e, link) {
    if (link && link.href) {
      link.href();
      return e && e.target && e.target.blur && e.target.blur();
    }
  }

  return (
    <div className='header-links'>
      {links.map((link, i) => (
        <Button
          key={link.id || `nav-link-${i}`}
          onClick={(e) => handleNavigationLinkPress(e, link)}
          tabIndex={0}
          variant='text'
          size='small'
          active={`'${isCurrentPage(link)}'`}
          className={`header-links__btn${isCurrentPage(link) ? ' current-page-link' : ''}`}
        >
          {localized[link.localizedLabelKey] || ''}
        </Button>
      ))}
    </div>
  );
}

HeaderLinks.propTypes = {
  localized: PropTypes.object
};
